import React, { useState, useEffect } from 'react';
import api from '../lib/api';
import { Link } from 'react-router-dom';

export default function TasksPage() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await api.get('/documents');
      const data = Array.isArray(response.data)
        ? response.data
        : (response.data?.tasks && Array.isArray(response.data.tasks) ? response.data.tasks : []);
      setTasks(data);
    } catch (err) {
      setError(true);
      console.error('Failed to fetch tasks:', err);
      setTasks([]);
    } finally {
      setLoading(false);
    }
  };

  const safeTasks = Array.isArray(tasks) ? tasks : [];

  const filtered = safeTasks.filter((task) => {
    const matchesSearch =
      task.title?.toLowerCase().includes(search.toLowerCase()) ||
      task.description?.toLowerCase().includes(search.toLowerCase());
    if (filter === 'all') return matchesSearch;
    if (filter === 'pending') return matchesSearch && task.status === 'pending';
    if (filter === 'in_progress') return matchesSearch && ['assigned', 'typing', 'review'].includes(task.status);
    if (filter === 'completed') return matchesSearch && task.status === 'done';
    return matchesSearch;
  });

  return (
    <div className="max-w-4xl mx-auto p-4 pb-nav">
      <h1 className="text-2xl font-bold mb-4">Available Tasks</h1>
      {error && <div role="alert" className="mb-4">Tasks could not load. <button onClick={fetchTasks} className="underline">Try again</button></div>}
      
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          placeholder="Search tasks..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border p-2 rounded w-full"
        />
      </div>

      <div className="flex gap-2 mb-6">
        {['all', 'pending', 'in_progress', 'completed'].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={`px-4 py-2 rounded capitalize ${
              filter === f ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'
            }`}
          >
            {f.replace('_', ' ')}
          </button>
        ))}
      </div>

      {loading ? (
        <p>Loading tasks...</p>
      ) : filtered.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          <p className="text-lg">No tasks found</p>
        </div>
      ) : (
        <div className="grid gap-4">
          {filtered.map((task) => (
            <div key={task.id || task._id} className="border p-4 rounded shadow-sm">
              <h3 className="font-semibold text-lg"><Link to={`/document/${task.id}`} className="underline">{task.title}</Link></h3>
              <p className="text-gray-600">{task.description}</p>
              <span className="inline-block mt-2 text-xs bg-gray-100 px-2 py-1 rounded">
                Status: {task.status}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
